// Values safe to use on the client. Next will inline these at build time.
export const BOOKING_URL: string = process.env.NEXT_PUBLIC_BOOKING_URL || "https://calendar.app.google/1h79XQbecTxyq9qf9"

